export default __webpack_public_path__ + "static/media/level.8e262b71.png";